import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6664560&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6664560')) {
      api.createRecord('f6664560', component.options)
    } else {
      api.reload('f6664560', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f6664560&", function () {
      api.rerender('f6664560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banks/index.vue"
export default component.exports